import { useMemo } from 'react';
import type { AuthSession } from '@/auth/types';
import type { NavItem } from '@/components/sidebarTypes';

export const useNavItems = (
  session: AuthSession | null,
  items: NavItem[],
): {
  navItemsForSession: NavItem[];
  isAdminUser: (session: AuthSession | null) => boolean;
  isSuperuser: (session: AuthSession | null) => boolean;
} => {
  const hasSuperuserEmailMatch = (s: AuthSession): boolean => s.superuserEmailMatched === true;

  const isSuperuser = (s: AuthSession | null): boolean => {
    if (!s) return false;
    return (s.roles ?? []).includes('superuser') && hasSuperuserEmailMatch(s);
  };
  const isAdminUser = (s: AuthSession | null): boolean => {
    if (!s) return false;
    return (s.roles ?? []).includes('admin') || isSuperuser(s);
  };

  const navItemsForSession = useMemo<NavItem[]>(() => {
    return items.filter((item) => {
      if (item.requiresSuperuser) {
        return session ? isSuperuser(session) : false;
      }
      if (item.requiresAdmin) {
        return session ? isAdminUser(session) : false;
      }
      return true;
    });
  }, [session, items]);

  return { navItemsForSession, isAdminUser, isSuperuser };
};
